<template>
  <div class="w-100 no-gap">
    <CCarousel
        v-if="slides.length"
        class="ccarousel"
        arrows
        indicators
        animate
    >
      <CCarouselItem
          v-for="(slide, index) in slides"
          :key="slide._id"
          :captionHeader="slide.slide_header"
          :captionText="slide.slide_label"
      >
        <template #default>
          <div class="slide-wrapper position-relative">
            <img
                :src="getFullImagePath(slide.slide_img)"
                alt="Slide Image"
                class="carousel-item-img"
            />
            <div class="slide-overlay"></div>
            <div class="carousel-caption">
              <h3>{{ slide.slide_header }}</h3>
              <p>{{ slide.slide_label }}</p>

            </div>
          </div>
        </template>
      </CCarouselItem>
    </CCarousel>
  </div>
</template>

<script>
import api from '@/service/api'
import '@/assets/css/slide.css'

export default {
  name: 'Slide',
  data() {
    return {
      slides: [],
      allowedIds: [
        '687f2e24420b887eea1f2f22',
        '687f2e4d420b887eea1f2f25',
        '687f2e71420b887eea1f2f28',
      ],
    }
  },
  mounted() {
    this.fetchSlides()
  },
  methods: {
    async fetchSlides() {
      try {
        const res = await api.slide('get')
        this.slides = (res.data.data || [])
            .filter(slide => this.allowedIds.includes(slide._id))
            .map(slide => ({
              ...slide,
              updatedAt: slide.updatedAt || new Date(),
            }))
        await this.$nextTick() // ensure carousel re-init
      } catch (err) {
        console.error(err)
      }
    },
    getFullImagePath(path) {
      return path ? `https://election-su.mfu.ac.th${path}` : ''
      //  return path ? `http://127.0.0.1:8030${path}` : ''
    },
  },
}
</script>
